
<template>
<div>
    <div id="map" class="min-h-70"></div>
</div>
</template>

<script >
    export default {
        props : ['zoneliste','nameproject'],     
        data:function(){
            return{
                questionRate:0,
            };
        },
        mounted: function(){
            const redirectToSiteEdition = (nameproject, id) => {
                return () => {
                    window.location.href = '/'+nameproject +'/editSite/'+id+"/" + window.default_locale;
                }
            };

            const token = process.env.MIX_GOOGLE_MAP_KEY;
            const GoogleMap = require("@googlemaps/js-api-loader");

            const loader = new GoogleMap.Loader({
                apiKey: token,
                version: "weekly",
            });

            loader.load().then(() => {
                // Initiate map
                let map;
                if(this.zoneliste.length == 0){
                    map = new google.maps.Map(document.querySelector("#map"), {
                        zoom: 1,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                        mapTypeControl: false,
                        center: {lat: 1, lng: 1},
                        tilt: 0,
                        rotateControl: false,
                    });
                } else {
                    var data=[]
                    this.zoneliste.forEach(element => {
                        data.push(turf.point([element.longitude,element.latitude]));
                    });
                    var center = turf.centerOfMass(turf.featureCollection(data));
                    var distance = -1;
                    this.zoneliste.forEach(element => {
                        var temp = turf.distance(center,turf.point([element.longitude,element.latitude]));
                        if(temp>distance){
                            distance=temp*3;
                        }
                    });
                    var div = document.getElementById('map');
                    var rapport = distance*1000/div.clientWidth;
                    var zoomRapport = 0;
                    if(rapport<0.019){
                        zoomRapport=22;
                    }else if(rapport <0.037){
                        zoomRapport=21;
                    }else if(rapport <0.075){
                        zoomRapport=20;
                    }else if(rapport <0.149){
                        zoomRapport=19;
                    }else if(rapport <0.299){
                        zoomRapport=18;
                    }else if(rapport <0.597){
                        zoomRapport=17;
                    }else if(rapport <1.194){
                        zoomRapport=16;
                    }else if(rapport <2.389){
                        zoomRapport=15;
                    }else if(rapport <4.777){
                        zoomRapport=14;
                    }else if(rapport <9.555){
                        zoomRapport=13;
                    }else if(rapport <19.102){
                        zoomRapport=12;
                    }else if(rapport <38.218){
                        zoomRapport=11;
                    }else if(rapport <76.437){
                        zoomRapport=10;
                    }else if(rapport <152.874){
                        zoomRapport=9;
                    }else if(rapport <305.748){
                        zoomRapport=8;
                    }else if(rapport <611.496){
                        zoomRapport=7;
                    }else if(rapport <1222.992){
                        zoomRapport=6;
                    }else if(rapport <2445.984){
                        zoomRapport=5;
                    }else if(rapport <4891.968){
                        zoomRapport=4;
                    }else if(rapport <9783.936){
                        zoomRapport=3;
                    }else if(rapport <19567.871){
                        zoomRapport=2;
                    }else{
                        zoomRapport=1;
                    }

                    map = new google.maps.Map(document.querySelector("#map"), {
                        zoom: zoomRapport - 1,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                        tilt: 0,
                        mapTypeControl: false,
                        center: { lng: center.geometry.coordinates[0], lat: center.geometry.coordinates[1]},
                        rotateControl: false,
                    });

                    this.zoneliste.forEach(element=>{
                        if(element.action>0){
                            var poppupContent = document.createElement("div");
                            poppupContent.className = "containeur-fluid d-print-flex flex-column justify-content-around align-content-center";
                            var text = document.createElement("div");
                            text.className = "text-center";
                            text.textContent = element.name;
                            poppupContent.appendChild(text);
                            var text2 = document.createElement("div");
                            text2.className = "text-center";
                            text2.textContent = "Il y a " + element.action + " action(s) à réaliser";
                            poppupContent.appendChild(text2);
                            var button = document.createElement('button');
                            button.className ="buttonOriginal";
                            button.setAttribute('id',element.id);

                            var glyph =document.createElement('span')
                            glyph.className="glyphicon glyphicon-search"
                            button.appendChild(glyph);
                            poppupContent.appendChild(button);
                            button.addEventListener('click', redirectToSiteEdition(nameproject, element.id));
                            var image = '/image/maps/a1.png';
                            const marker = new google.maps.Marker({
                                map,
                                position: { lat: element.latitude, lng: element.longitude},
                                icon: image,
                            });

                            const infowindow = new google.maps.InfoWindow({
                                content: poppupContent,
                            });

                            marker.addListener("click", () => {
                                infowindow.open({
                                    anchor: marker,
                                    map,
                                    shouldFocus: false,
                                });
                            });

                            //document.getElementById(element.id).addEventListener('click', go(element.id));
                        } else if(element.building.length == 0){

                            var poppupContent = document.createElement("div");
                            poppupContent.className = "containeur-fluid d-print-flex flex-column justify-content-around align-content-center";

                            var text = document.createElement("div");
                            text.className = "text-center";

                            text.textContent = element.name;
                            poppupContent.appendChild(text);
                            
                            var text2 = document.createElement("div");
                            text2.className = "text-center";
                            text2.textContent = "Il n'y a pas de zone référencée";
                            poppupContent.appendChild(text2);

                            var button = document.createElement('button');
                            button.className ="buttonOriginal";

                            button.setAttribute('id',element.id);

                            var glyph =document.createElement('span')
                            
                            glyph.className="glyphicon glyphicon-search"

                            button.appendChild(glyph);

                            poppupContent.appendChild(button);
                            button.addEventListener('click', redirectToSiteEdition(nameproject, element.id));

                            
                            var contentText = poppupContent.outerHTML;
                            var image = '/image/maps/a1.png';
                            const marker = new google.maps.Marker({
                                map,
                                position: { lat: element.latitude, lng: element.longitude},
                                icon: image
                            });

                            const infowindow = new google.maps.InfoWindow({
                                content: poppupContent,
                            });

                            marker.addListener("click", () => {
                                infowindow.open({
                                    anchor: marker,
                                    map,
                                    shouldFocus: false,
                                });
                            });
                        } else {

                            var poppupContent = document.createElement("div");
                            poppupContent.className = "containeur-fluid d-print-flex flex-column justify-content-around align-content-center";

                            var text = document.createElement("div");
                            text.className = "text-center";

                            text.textContent = element.name;
                            poppupContent.appendChild(text);                      

                            var button = document.createElement('button');
                            button.className ="buttonOriginal";
                            button.addEventListener('click', redirectToSiteEdition(nameproject, element.id));

                            button.setAttribute('id',element.id);
                            
                            var glyph =document.createElement('span')
                            
                            glyph.className="glyphicon glyphicon-search"

                            button.appendChild(glyph);


                            poppupContent.appendChild(button);
                            
                            var contentText = poppupContent.outerHTML;
                            
                            var image = '/image/maps/'+element.statut+'.png';

                            const marker = new google.maps.Marker({
                                map,
                                position: { lat: element.latitude, lng: element.longitude},
                                icon: image
                            });

                            const infowindow = new google.maps.InfoWindow({
                                content: poppupContent,
                            });

                            marker.addListener("click", () => {
                                infowindow.open({
                                    anchor: marker,
                                    map,
                                    shouldFocus: false,
                                });
                            });
                            
                        }

                    });

                    const { getCadastreLayer, getPLULayer, getOverlayControls, getOverlayLegend } = require("./maps/additional-layers.js");
                    const { EnedisHTLines, EnedisBTLines, EnedisDeliveryPosts, EnedisSourcePosts, RteLines, RtePylones, RtePostes } = require("./maps/opendata-carto-module.js");

                    const overlaysMenu = getOverlayControls({
                        'cadastre': getCadastreLayer(),
                        'urbanism': getPLULayer(map),
                        'ht-lines': new EnedisHTLines(),
                        'bt-lines': new EnedisBTLines(),
                        'posts': new EnedisDeliveryPosts(),
                        'source-posts': new EnedisSourcePosts(),
                        'rte-posts': new RtePostes(),
                        'rte-lines': new RteLines(),
                        'rte-pylones': new RtePylones(),
                    }, map);

                    map.controls[google.maps.ControlPosition.TOP_LEFT].push(overlaysMenu);

                    const overlayLegend = getOverlayLegend();
                    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(overlayLegend);
                }
            });
                var nameproject =this.nameproject;
        },

    }

</script>
